import styled from "styled-components";

export { Collapse } from "./Collapse/Collapse";
export { Expand } from "./Expand/Expand";

/**
 * A flexible container component for grouping elements.
 *
 * @param {Object} props - The component props
 * @param {'row' | 'column'} [props.direction='row'] - The flex direction of the container
 * @param {'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly'} [props.justify='flex-start'] - The justification of the container's contents
 * @param {'flex-start' | 'flex-end' | 'center' | 'baseline' | 'stretch'} [props.align='flex-start'] - The alignment of the container's contents
 * @param {string} [props.gap='10px'] - The gap between child elements
 * @param {string} [props.width='100%'] - The width of the container
 * @param {string} [props.margin='0'] - The margin around the container
 * @param {string} [props.flex='0 1 auto'] - The flex property of the container
 */
export const Group = styled.div`
  display: flex;
  flex-direction: ${({ direction }) => direction || "row"};
  justify-content: ${({ justify }) => justify || "flex-start"};
  align-items: ${({ align }) => align || "flex-start"};
  gap: ${({ gap }) => gap || "10px"};
  width: ${({ width }) => width || "100%"};
  margin: ${({ margin }) => margin || "0"};
  flex: ${({ flex }) => flex || "0 1 auto"};
`;

export const CollapseContainer = styled.div`
  flex: ${({ flex }) => flex};
  width: ${({ width }) => width};
`;
